export const languageCodesGetAdapter = async (data: any): Promise<any> => {
  return data;
};

export const languageCodesPostAdapter = async (languages: any): Promise<any> => {
  return languages.map((language: any) => ({ code: language.code }));
};